const initialData = {
    list : [{
        id: 1,
        data: "jayesh"
    },
    {
        id: 2,
        data: "Todo1"
    },
    {
        id: 3,
        data: "Todo2"
    },
    {
        id: 4,
        data: "Todo3"
    },],
}

const facebookReducer = (state=initialData, action)=>{
    switch(action.type){
        case "APICALL" : return state
        default : return state    
    }
}

export default facebookReducer